export default __webpack_public_path__ + "static/media/iconesCompradoresMaior.d14d99a9.png";